import type { ColorSwatches } from '@/util/color_swatch';

let request: Promise<ColorSwatches | null> | null = null;

/**
 * Color filter swatches from `/api/product/color-swatches`, fetched once and
 * shared by every circle in the filter. Resolves null (plain labels) when the
 * fetch fails or no color has a hex yet, and lets the next call try again.
 */
export function fetchColorSwatches(): Promise<ColorSwatches | null> {
  request ??= fetch('/api/product/color-swatches')
    .then((response) => (response.ok ? response.json() : {}))
    .catch(() => ({}))
    .then((swatches: ColorSwatches) => {
      if (Object.values(swatches).some(({ background }) => background)) {
        return swatches;
      }
      request = null;
      return null;
    });
  return request;
}
